import { RadioTower } from "lucide-react";
import { useEffect, useState } from "react";
import ToggleSwitch from "components/ToggleSwitch/ToggleSwitch";
import { useCollection } from "functions/hooks/useCollection";
import { errorAsync, successAsync } from "functions/notification";
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";

export default function ViewMgtDeviceConfigTrackerOnly({ deviceId, device }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {
    const devicesCollection = useCollection<any>("devices");
    const [updating, setUpdating] = useState(false);
    const [isTrackerOnly, setIsTrackerOnly] = useState<boolean>(Boolean(device?.isTrackerOnly));

    useEffect(() => {
        setIsTrackerOnly(Boolean(device?.isTrackerOnly));
    }, [device?.isTrackerOnly]);

    async function handleToggle(event: any) {
        if (!deviceId || updating) return;

        const nextValue = Boolean(event?.target?.checked);
        const previousValue = Boolean(device?.isTrackerOnly);

        setIsTrackerOnly(nextValue);
        setUpdating(true);

        try {
            await devicesCollection.updateOne(deviceId, { isTrackerOnly: nextValue });
            successAsync(`Tracker-only mode ${nextValue ? "enabled" : "disabled"}`);
        } catch (error: any) {
            setIsTrackerOnly(previousValue);
            errorAsync(`Failed to update tracker-only mode: ${error?.message || error}`, error);
        } finally {
            setUpdating(false);
        }
    }

    return (
        <ViewMgtDevicePanel title="Device" icon={<RadioTower size={16} />} fullWidth collapsible collapsed>
            <div className="p-2">
                <ToggleSwitch
                    htmlFor="isTrackerOnly"
                    label={updating ? "Tracker-only mode (saving...)" : "Tracker-only mode"}
                    checked={isTrackerOnly}
                    onChange={handleToggle}
                />
            </div>
        </ViewMgtDevicePanel>
    );
}